import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import Select from "react-select"
import { updateJobServiceTransition, approveCadastralRequestForJobService, getCadastralSurveyorOptions } from "requesters/jobServiceRequester"
import { Modal, Spinner } from "react-bootstrap"
import { REQUEST_CADASTRAL, DECLINE_CADASTRAL, APPROVE_CADASTRAL } from "utils/constants"
import { getBaseUrl, getCurrentUser } from "../../../reducers"
import { getSurveyorsByType } from "../../../../../requesters/userRequester"

const DECLINE_PROPERTIES = {
  header: "Decline Cadastral request",
  subHeader: "Enter the reasons why the request is declined",
  apiTransition: DECLINE_CADASTRAL,
  buttonLabel: "Decline Request",
  notesPlaceholder: "Enter the reasons why the request is declined"
}
const APPROVE_PROPERTIES = {
  header: "Approve Cadastral request",
  subHeader: "",
  apiTransition: APPROVE_CADASTRAL,
  buttonLabel: "Approve Request",
  notesPlaceholder: "Enter the reasons why the request is approved (optional)"
}

const CadastralRequestModal = ({
  show, onHide, jobService, reloadData, action
}) => {
  const { id } = jobService
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const [modalContent, setModalContent] = useState({})
  const [notes, setNotes] = useState("")
  const [requesting, setRequesting] = useState(false)
  const [cadastralSurveyorOptions, setCadastralSurveyorOptions] = useState([])
  const [selectedCadastralSurveyorId, setSelectedCadastralSurveyorId] = useState(null)

  const fetchCadastralSurveyorOptions = () => {
    setRequesting(true)
    getCadastralSurveyorOptions(baseUrl, id)
    .then(res => {
      if (res.status === 200) {
        const options = res.response.map(s => ({ label: `${s[0]} ${s[1]}`, value: s[2] }))
        setCadastralSurveyorOptions(options)
        setRequesting(false)
      }
    })
    .catch(error => {
      console.error(error)
      setRequesting(false)
    })
  }

  const initData = () => {
    if (action === "decline") setModalContent(DECLINE_PROPERTIES);
    if (action === "approve") {
      fetchCadastralSurveyorOptions()
      setModalContent(APPROVE_PROPERTIES)
    }
  }

  const onDecline = () => {
    setRequesting(true)
    updateJobServiceTransition(baseUrl, id, modalContent?.apiTransition, notes)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        onHide()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  const onApprove = () => {
    const payload = {
      comment: notes,
      surveyor_id: selectedCadastralSurveyorId
    }
    setRequesting(true)
    approveCadastralRequestForJobService(baseUrl, id, payload)
    .then(res => {
      if (res.status === 200) {
        window.location.reload()
        reloadData()
        onHide()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  const onSubmit = () => {
    if (action === "decline") onDecline();
    if (action === "approve") onApprove();
  }

  useEffect(() => {
    if (show) {
      initData()
      setRequesting(false)
    }
  }, [show])

  const canSubmit = ((action === "decline" && notes?.trim()) || (action === "approve" && !!selectedCadastralSurveyorId)) && !requesting

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <h2 className="modal-title">{modalContent?.header}</h2>
          <div className="mb-2 h6">
            <p className="mr-1">{modalContent?.subHeader}</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <div className="modal-body px-md-5">
        <form>
          { action === "approve" && (
            <div className="form-group row mb-4 pb-4">
              <label className="col-3 col-form-label">Cadastral Surveyor*</label>
              <div className="col-7">
                <Select
                  isClearable
                  isSearchable
                  disabled={requesting}
                  name="cadastral_surveyor"
                  onChange={e => setSelectedCadastralSurveyorId(e?.value || null)}
                  options={cadastralSurveyorOptions}
                  placeholder="Select Cadastral Surveyor"
                  value={cadastralSurveyorOptions.find(s => s.value === selectedCadastralSurveyorId)} />
              </div>
            </div>
          )}

          <div className="form-group row mb-4 pb-4 border-bottom">
            <textarea
              name="cadastral_notes"
              className="form-control mr-5"
              placeholder={modalContent?.notesPlaceholder}
              rows="4"
              value={notes}
              onChange={e => setNotes(e.target.value)}>
            </textarea>
          </div>
        </form>
        <div className="modal-footer d-flex justify-content-end px-0 py-4">
          <button
            className="btn btn-link btn-lg"
            onClick={onHide}
            type="submit">
            Close
          </button>
          <button
            className="btn btn-red btn-lg"
            onClick={onSubmit}
            disabled={!canSubmit}
            type="submit">
            {modalContent?.buttonLabel}
            {requesting && <Spinner className="ml-1" animation="border" role="status" size="sm" />}
          </button>
        </div>
      </div>
    </Modal>
  )
}
export default CadastralRequestModal
